export default "__VITE_ASSET__Bz2st_WR__"